import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=6f196231"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"
import style0 from "./Box.vue?vue&type=style&index=0&id=6f196231&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports